import Widgets from 'js-widget-hooks';

Widgets.register('fileuploader', function (el) {
    import(/* webpackChunkName: "map" */ '../fileuploader/uploader').then(function (module) {
        module.default(el);
    })
});